export const IconProductBlgMolecule = () => {
  return (
    <>
      <div className="w-full mt-7 lg:w-93/100 max-w-full hidden lg:block">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          viewBox="0 0 528.966 341.201"
        >
          <text
            id="_100_protection_against_UV-A_and_UV-B_rays"
            data-name="100% protection
against UV-A and
UV-B rays"
            transform="translate(147.109 14)"
            fill="#fff"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="0" className="waldo-sans font-light text-sm">
              100% protection
            </tspan>
            <tspan x="0" y="19" className="waldo-sans font-light text-sm">
              against{' '}
            </tspan>
            <tspan y="19" className="waldo-sans font-medium text-sm">
              UV-A
            </tspan>
            <tspan
              y="19"
              xmlSpace="preserve"
              className="waldo-sans font-light text-sm"
            >
              {' '}
              and
            </tspan>
            <tspan className="waldo-sans font-normal text-sm">
              <tspan x="0" y="38">
                UV-B rays
              </tspan>
            </tspan>
          </text>
          <text
            id="Adjustable_acetate_frames_made_from_renewable_resources_and_biodegradable_materials"
            data-name="Adjustable acetate frames,
made from renewable
resources and biodegradable
materials"
            transform="translate(147.109 278.201)"
            fill="#fff"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="0" className="waldo-sans font-light text-sm">
              Adjustable acetate frames,
            </tspan>
            <tspan x="0" y="19" className="waldo-sans font-light text-sm">
              made from renewable
            </tspan>
            <tspan x="0" y="38" className="waldo-sans font-light text-sm">
              resources and biodegradable
            </tspan>
            <tspan x="0" y="57" className="waldo-sans font-light text-sm">
              materials
            </tspan>
          </text>
          <path
            id="Path_426"
            data-name="Path 426"
            d="M0,0V320"
            transform="translate(277.628 24.762) rotate(60)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <path
            id="Path_427"
            data-name="Path 427"
            d="M0,0V320"
            transform="translate(277.628 156.201) rotate(60)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <path
            id="Path_428"
            data-name="Path 428"
            d="M0,0V320"
            transform="translate(277.628 84.183) rotate(60)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <path
            id="Path_429"
            data-name="Path 429"
            d="M0,0V339.2"
            transform="translate(90.499)"
            fill="none"
            stroke="#fe5000"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <g
            id="Group_588"
            data-name="Group 588"
            transform="translate(61.999 142.575)"
          >
            <g
              id="Ellipse_47"
              data-name="Ellipse 47"
              fill="none"
              stroke="#fff"
              strokeWidth="1"
            >
              <ellipse cx="10.5" cy="30" rx="10.5" ry="30" stroke="none" />
              <ellipse cx="10.5" cy="30" rx="10" ry="29.5" fill="none" />
            </g>
            <g
              id="Group_580"
              data-name="Group 580"
              transform="translate(23.131 8.894)"
            >
              <path
                id="Path_391"
                data-name="Path 391"
                d="M3883.39,4515.894s122.941,6.871,131.276,8.967,33.18,22.625,37.044,24.393,10.581,2.147,10.657,5.253-5.706,12.4-10.657,3.106-30.094-26.77-37.044-28.386-129.057-4.366-129.057-4.366Z"
                transform="translate(-3868.995 -4515.894)"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
              />
              <path
                id="Path_393"
                data-name="Path 393"
                d="M3875.131,4495.964l10.9-10.9"
                transform="translate(-3875.131 -4482.894)"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
                strokeDasharray="1"
              />
            </g>
          </g>
          <text
            id="Anti_glare_anti-reflective_and_scratch_resistant_lens"
            data-name="Anti glare, anti-reflective
and scratch resistant lens"
            transform="translate(147.109 113.768)"
            fill="#fff"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="0" className="waldo-sans font-medium text-sm">
              Anti glare
            </tspan>
            <tspan y="0" className="waldo-sans font-light text-sm">
              ,{' '}
            </tspan>
            <tspan y="0" className="waldo-sans font-medium text-sm">
              anti-reflective
            </tspan>
            <tspan className="waldo-sans font-light text-sm">
              <tspan x="0" y="19" className="waldo-sans font-light text-sm">
                and{' '}
              </tspan>
              <tspan y="19" className="waldo-sans font-medium text-sm">
                scratch resistant
              </tspan>
              <tspan
                y="19"
                xmlSpace="preserve"
                className="waldo-sans font-light text-sm"
              >
                {' '}
                lens
              </tspan>
            </tspan>
          </text>
          <text
            id="Block_100_of_blue_light_up_to_410nm"
            data-name="Block 100% of
blue light up to 410nm"
            transform="translate(147.109 198.762)"
            fill="#fff"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="0" className="waldo-sans font-light text-sm">
              Block 100% of
            </tspan>
            <tspan x="0" y="19" className="waldo-sans font-light text-sm">
              blue light up to 410nm
            </tspan>
          </text>
          <line
            id="Line_229"
            data-name="Line 229"
            x2="33"
            transform="translate(101.999 26.713)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <line
            id="Line_230"
            data-name="Line 230"
            x2="33"
            transform="translate(101.999 117.514)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <line
            id="Line_231"
            data-name="Line 231"
            x2="33"
            transform="translate(101.999 203.322)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <line
            id="Line_232"
            data-name="Line 232"
            x2="33"
            transform="translate(101.999 297.701)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_430"
            data-name="Path 430"
            d="M0,0V339.2"
            transform="translate(370.271)"
            fill="none"
            stroke="#fff"
            strokeWidth="0.5"
          />
          <path
            id="Path_431"
            data-name="Path 431"
            d="M0,0V339.2"
            transform="translate(528.716)"
            fill="none"
            stroke="#fff"
            strokeWidth="0.5"
          />
          <g
            id="Group_639"
            data-name="Group 639"
            transform="translate(-974.501 -4519.516)"
          >
            <text
              id="Our_glasses_can_help_to_minimize_the_risks_of:"
              data-name="Our glasses can
help to minimize
the risks of:"
              transform="translate(1424.988 4553.616)"
              fill="#fff"
              className="waldo-sans font-light text-sm"
            >
              <tspan
                x="-53.802"
                y="0"
                className="waldo-sans font-light text-sm"
              >
                Our glasses can
              </tspan>
              <tspan
                x="-59.572"
                y="23"
                className="waldo-sans font-light text-sm"
              >
                help to minimize{' '}
              </tspan>
              <tspan
                x="-39.053"
                y="46"
                className="waldo-sans font-light text-sm"
              >
                the risks of:
              </tspan>
            </text>
            <text
              id="screen-related_eye_strain"
              data-name="screen-related
eye strain"
              transform="translate(1424.988 4641.616)"
              fill="#fff"
              className="waldo-sans  text-sm font-normal"
            >
              <tspan
                x="-51.755"
                y="0"
                className="waldo-sans text-sm font-normal"
              >
                screen-related
              </tspan>
              <tspan
                x="-34.581"
                y="23"
                className="waldo-sans  text-sm font-normal"
              >
                eye strain
              </tspan>
            </text>
            <text
              id="_sleep_cycle_disruption"
              data-name=" sleep cycle
disruption"
              transform="translate(1424.988 4727.616)"
              fill="#fff"
              className="waldo-sans text-sm font-normal"
            >
              <tspan
                x="-40.884"
                y="0"
                xmlSpace="preserve"
                className="waldo-sans  text-sm font-normal"
              >
                {' '}
                sleep cycle
              </tspan>
              <tspan
                x="-37.204"
                y="23"
                className="waldo-sans text-sm font-normal"
              >
                disruption
              </tspan>
            </text>
            <text
              id="macular_degeneration"
              data-name="macular
degeneration"
              transform="translate(1424.988 4813.616)"
              fill="#fff"
              className="waldo-sans  text-sm font-normal"
            >
              <tspan
                x="-29.584"
                y="0"
                className="waldo-sans  text-sm font-normal"
              >
                macular
              </tspan>
              <tspan
                x="-47.816"
                y="23"
                className="waldo-sans  text-sm font-normal"
              >
                degeneration
              </tspan>
            </text>
            <line
              id="Line_233"
              data-name="Line 233"
              x1="57.336"
              transform="translate(1396.488 4690.116)"
              fill="none"
              stroke="#fe5000"
              strokeWidth="0.5"
            />
            <line
              id="Line_234"
              data-name="Line 234"
              x1="57.336"
              transform="translate(1396.488 4776.116)"
              fill="none"
              stroke="#fe5000"
              strokeWidth="0.5"
            />
          </g>
        </svg>
      </div>
      <div className="mt-7 w-11/12 mb-5 mx-auto block lg:hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          viewBox="0 0 288.108 386.884"
        >
          <g
            id="Group_634"
            data-name="Group 634"
            transform="translate(-45 -6054)"
          >
            <text
              id="_100_protection_against_UV-A_and_UV-B_rays"
              data-name="100% protection
against UV-A and
UV-B rays"
              transform="translate(192.108 6066)"
              fill="#fff"
              className="waldo-sans font-light text-xs"
            >
              <tspan x="0" y="0" className="waldo-sans font-light text-xs">
                100% protection
              </tspan>
              <tspan x="0" y="16" className="waldo-sans font-light text-xs">
                against{' '}
              </tspan>
              <tspan y="16" className="waldo-sans font-medium text-xs">
                UV-A{' '}
              </tspan>
              <tspan y="16" className="waldo-sans font-light text-xs">
                and
              </tspan>
              <tspan className="waldo-sans font-medium text-xs">
                <tspan x="0" y="32">
                  UV-B rays
                </tspan>
              </tspan>
            </text>
            <text
              id="Adjustable_acetate_frames_made_from_renewable_resources_and_biodegradable_materials"
              data-name="Adjustable acetate frames,
made from renewable
resources and biodegradable
materials"
              transform="translate(192.108 6373)"
              fill="#fff"
              className="waldo-sans font-light text-xs"
            >
              <tspan x="0" y="0" className="waldo-sans font-light text-xs">
                Adjustable acetate frames,
              </tspan>
              <tspan x="0" y="16" className="waldo-sans font-light text-xs">
                made from renewable
              </tspan>
              <tspan x="0" y="32" className="waldo-sans font-light text-xs">
                resources and biodegradable
              </tspan>
              <tspan x="0" y="48" className="waldo-sans font-light text-xs">
                materials
              </tspan>
            </text>
            <path
              id="Path_385"
              data-name="Path 385"
              d="M0,0V320"
              transform="translate(322.628 6078.964) rotate(60)"
              fill="none"
              stroke="#0057b7"
              strokeWidth="2"
              strokeDasharray="1"
            />
            <path
              id="Path_387"
              data-name="Path 387"
              d="M0,0V320"
              transform="translate(322.628 6251) rotate(60)"
              fill="none"
              stroke="#0057b7"
              strokeWidth="2"
              strokeDasharray="1"
            />
            <path
              id="Path_388"
              data-name="Path 388"
              d="M0,0V320"
              transform="translate(322.628 6142.376) rotate(60)"
              fill="none"
              stroke="#0057b7"
              strokeWidth="2"
              strokeDasharray="1"
            />
            <path
              id="Path_392"
              data-name="Path 392"
              d="M0,0V379.768"
              transform="translate(135.5 6061.116)"
              fill="none"
              stroke="#fe5000"
              strokeWidth="2"
              strokeDasharray="1"
            />
            <g
              id="Group_581"
              data-name="Group 581"
              transform="translate(28 -93)"
            >
              <g
                id="Ellipse_47"
                data-name="Ellipse 47"
                transform="translate(79 6309)"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
              >
                <ellipse cx="10.5" cy="30" rx="10.5" ry="30" stroke="none" />
                <ellipse cx="10.5" cy="30" rx="10" ry="29.5" fill="none" />
              </g>
              <g id="Group_580" data-name="Group 580">
                <path
                  id="Path_391"
                  data-name="Path 391"
                  d="M3883.39,4515.894s122.941,6.871,131.276,8.967,33.18,22.625,37.044,24.393,10.581,2.147,10.657,5.253-5.706,12.4-10.657,3.106-30.094-26.77-37.044-28.386-129.057-4.366-129.057-4.366Z"
                  transform="translate(-3766.864 1802)"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1"
                />
                <path
                  id="Path_393"
                  data-name="Path 393"
                  d="M3875.131,4495.964l10.9-10.9"
                  transform="translate(-3773 1835)"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1"
                  strokeDasharray="1"
                />
              </g>
            </g>
            <text
              id="Anti_glare_anti-reflective_and_scratch_resistant_lens"
              data-name="Anti glare, anti-reflective
and scratch resistant lens"
              transform="translate(192.108 6179)"
              fill="#fff"
              className="waldo-sans font-light text-xs"
            >
              <tspan x="0" y="0" className="waldo-sans font-medium text-xs">
                Anti glare
              </tspan>
              <tspan y="0" className="waldo-sans font-light text-xs">
                ,{' '}
              </tspan>
              <tspan y="0" className="waldo-sans font-medium text-xs">
                anti-reflective
              </tspan>
              <tspan className="waldo-sans font-light text-xs">
                <tspan x="0" y="16" className="waldo-sans font-light text-xs">
                  and{' '}
                </tspan>
                <tspan y="16" className="waldo-sans font-medium text-xs">
                  scratch resistant
                </tspan>
                <tspan y="16" className="waldo-sans font-light text-xs">
                  {' '}
                  lens
                </tspan>
              </tspan>
            </text>
            <text
              id="Block_100_of_blue_light_up_to_410nm"
              data-name="Block 100% of
blue light up to 410nm"
              transform="translate(192.108 6276)"
              fill="#fff"
              className="waldo-sans font-light text-xs"
            >
              <tspan x="0" y="0" className="waldo-sans font-light text-xs">
                Block 100% of
              </tspan>
              <tspan x="0" y="16" className="waldo-sans font-light text-xs">
                blue light up to 410nm
              </tspan>
            </text>
            <line
              id="Line_190"
              data-name="Line 190"
              x2="33"
              transform="translate(147 6079.855)"
              fill="none"
              stroke="#0057b7"
              strokeWidth="1"
            />
            <line
              id="Line_197"
              data-name="Line 197"
              x2="33"
              transform="translate(147 6182.5)"
              fill="none"
              stroke="#0057b7"
              strokeWidth="1"
            />
            <line
              id="Line_198"
              data-name="Line 198"
              x2="33"
              transform="translate(147 6279.5)"
              fill="none"
              stroke="#0057b7"
              strokeWidth="1"
            />
            <line
              id="Line_199"
              data-name="Line 199"
              x2="33"
              transform="translate(147 6392.5)"
              fill="none"
              stroke="#0057b7"
              strokeWidth="1"
            />
          </g>
        </svg>
      </div>
    </>
  );
};
